import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class StockListado {
  getExistenciaDiariaVariedad (fecha) {
    const axios = getAxiosInstance()
    const orden = '"orden":["cereal", "cereal_variedad"]'
    const filtro = `{"clave":{"fecha": "${fecha}"}, ${orden}}`
    const promise = axios.get(`consulta_existencia_diaria?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getExistenciaDiariaPorCereal (fecha) {
    const axios = getAxiosInstance()
    const orden = '"orden":["cereal"]'
    const filtro = `{"clave":{"fecha": "${fecha}"}, ${orden}}`
    const promise = axios.get(`consulta_existencia_diaria_por_cereal?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getMercaderiaEnTerminalTotal () {
    const axios = getAxiosInstance()
    const promise = axios.get('consulta_mercaderia_en_terminal_total')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getMercaderiaFumigada (fechaD, cuit, cereal, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden":["cereal", "cereal_variedad"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}", "exportador": "${cuit}", "cereal":"${cereal}"}, ${orden}}`
    const promise = axios.get(`/consulta_liquidacion_fumigado_listado?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  };

  getTotalizadorMercaderiaFumigada (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden":["razon_social_exportador", "nombre_cereal", "cereal_variedad"]'
    const filtro = `{"parametros":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden} }`
    const promise = axios.get(`/consulta_liquidacion_fumigado_totalizadora?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  };

  getMercaderiaSecada (fechaD, cuit, cereal, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden":["cereal", "cereal_variedad"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}", "exportador": "${cuit}", "cereal":"${cereal}"}, ${orden}}`
    const promise = axios.get(`/consulta_liquidacion_secado_2_listado?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  getTotalizadorMercaderiaSecada (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden":["nombre_cereal", "cereal_variedad"]'
    const filtro = `{"parametros":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`
    const promise = axios.get(`/consulta_liquidacion_secado_totalizadora?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getMercaderiaSecadaDosMasTotal (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden":["cereal", "cereal_variedad"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`
    const promise = axios.get(`/consulta_liquidacion_secado_2_mas_total?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getDetalleMercaderiaSecadaDosMas (fecha, exportador, cereal) {
    const axios = getAxiosInstance()
    const orden = '"orden":["cereal", "cereal_variedad"]'
    const filtro = `{"clave":{"fecha": "${fecha}", "exportador": "${exportador}", "cereal":"${cereal}"}, ${orden}}`
    const promise = axios.get(`/consulta_liquidacion_secado_2_mas?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  getDescargaPorGradoTotal (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"parametros":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`descarga_por_grado_total_por_fecha?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getDescargaGrado3Total (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"parametros":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`liquidacion_grado_3_total_por_fecha?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getDetalleDescargaPorGrado (fechaD, exportador, cereal, fechaH, variedad) {
    const axios = getAxiosInstance()
    const orden = '"orden":["fecha_de_descarga", "cereal", "cargador"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}", "exportador": "${exportador}", "cereal": "${cereal}", "variedad": "${variedad}"}, ${orden}}`
    const promise = axios.get(`consulta_descarga_por_grado?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  getDetalleMercaderiaGrado3 (fechaD, exportador, cereal, fechaH, variedad) {
    const axios = getAxiosInstance()
    const orden = '"orden":["fecha_de_descarga", "cereal", "cargador"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}", "exportador": "${exportador}", "cereal": "${cereal}", "variedad": "${variedad}"}, ${orden}}`
    const promise = axios.get(`consulta_liquidacion_grado_3?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  getLiquidacionFueraDeGrado (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"parametros":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`liquidacion_fuera_de_grado?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getDetalleFueraDeGrado (fechaD, exportador, cereal, fechaH, variedad) {
    const axios = getAxiosInstance()
    const orden = '"orden":["fecha_de_descarga", "cereal", "cargador"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}", "exportador": "${exportador}", "cereal": "${cereal}", "variedad": "${variedad}"}, ${orden}}`
    const promise = axios.get(`consulta_liquidacion_fuera_de_grado?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  getMercaderiaRebajaAdicional (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`consulta_rebajas_adicionales?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getDetalleMovimientosExportadores (fechaD, exportador, cereal, fechaH, variedad) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde":"${fechaD}", "fecha_hasta":"${fechaH}", "exportador": "${exportador}", "cereal":"${cereal}", "variedad":"${variedad}"}}`
    const promise = axios.get(`consulta_movimientos_exportador_exportador_cereal?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getMovimientosExportadores (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden":["cereal", "razon_social"]'
    const filtro = `{"parametros":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`
    const promise = axios.get(`resumen_movimientos_exportador_cereal?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getTotalAlmacenaje (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden": ["cereal", "cereal_variedad"]'
    const filtro = `{"parametros":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`
    const promise = axios.get(`consulta_reporte_almacenaje_total?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getAlmacenajeEspecial (fechaD, fechaH, cereal) {
    const axios = getAxiosInstance()
    const orden = '"orden": ["cereal"]'
    const filtro = `{"parametros":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}", "cereal": "${cereal}"}, ${orden}}`
    const promise = axios.get(`reporte_almacenaje_especial_total?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getDetalleAlmacenajeEspecial (fechaD, exportador, cereal, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden":["fecha", "cereal_variedad"]'
    const filtro = `{"parametros":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}", "exportador": "${exportador}", "cereal": "${cereal}"}, ${orden}}`
    const promise = axios.get(`detalle_almacenaje_especial?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  getTotalZarandeo (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden": ["fecha_de_descarga", "cereal"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`
    const promise = axios.get(`consulta_liquidacion_zarandeo_total?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getDetalleZarandeo (fecha, exportador, cereal) {
    const axios = getAxiosInstance()
    const filtro = `{"clave": {"exportador": "${exportador}", "cereal": "${cereal}", "fecha": "${fecha}"}}`
    const promise = axios.get(`consulta_liquidacion_zarandeo?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  getIndices () {
    const axios = getAxiosInstance()
    const promise = axios.get('consulta_liquidacion_indice_calidad')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getReconocimientoStock () {
    const axios = getAxiosInstance()
    const filtro = '{"orden": ["d:fecha"]}'
    const promise = axios.get(`consulta_reconocimiento_de_stock_listado?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getStockPresuntoTerminal () {
    const axios = getAxiosInstance()
    const filtro = '{"orden": ["d:fecha"]}'
    const promise = axios.get(`consulta_ultimo_stock_presunto_terminal_listado?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getConsultaPorCosecha (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"parametros": {"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`stock_por_cosecha_total?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getDetalleConsultaPorCosecha (valores) {
    const axios = getAxiosInstance()
    const fechaD = valores.fechaDesde
    const fechaH = valores.fechaHasta
    const filtro = `{"clave": {"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}", "cereal": "${valores.cereal}", "cosecha": "${valores.cosecha}", "variedad": "${valores.variedad}"}}`
    const promise = axios.get(`consulta_detalle_stock_por_cosecha?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getEstimacionSemanal () {
    const axios = getAxiosInstance()
    const promise = axios.get('estimacion_stock_presunto')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getEstimacionSemanalExportador (exportador) {
    const axios = getAxiosInstance()
    const filtro = `{"clave": { "exportador": "${exportador}" }}`
    const promise = axios.get(`estimacion_stock_presunto_exportador?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getEstimacionSemanalExportadores () {
    const axios = getAxiosInstance()
    const promise = axios.get('estimacion_stock_presunto_exportador_todos')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getEstimacionSemanalCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get('resumen_estimacion_semanal_stock_presunto')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getUltimoStockExportadores () {
    const axios = getAxiosInstance()
    const promise = axios.get('resumen_ultimo_stock_exportadores_cereal_variedad')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }
}

export default StockListado
